
import ClientAPI from './modules/client';
import SubjectAPI from './modules/subject';

export default {
  ...ClientAPI,
  ...SubjectAPI,
};
